import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../../components/RenderNavItem";
import { GrievanceRedressalLeftMenuList } from "../../utils/constants";

const TERM_Cell = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass">{t("About_Kolkata")} </h4>
            </div>
          </div>
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {GrievanceRedressalLeftMenuList.map((item, index) => (
                      <RenderNavItem
                        key={item.id || index}
                        item={item}
                        index={index}
                        t={t}
                      />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">{t("Procedure")}</h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    <h5 className="fontSizeClass">
                      <strong>
                        {t(
                          "Address of TERM Cell for grievances regarding radiation from mobile tower :"
                        )}
                      </strong>
                    </h5>
                  </div>

                  <div className="about-img3 mt-4 mr-4">
                    <p>
                      Dy. Director General <br></br>
                      Telecom Enforcement Resource & Monitoring Cell (TERM Cell)
                      <br></br>
                      Department of Telecommunications<br></br>
                      QA Bhawan <br></br>
                      Block -EP&GP, Sector -V <br></br>
                      Sector -V Salt Lake, Kolkata - 700091
                    </p>
                    <br></br>
                  </div>

                  <div className="about-img3 mt-4">
                    <p>
                      <strong> Phone : </strong>
                    </p>
                    <br></br>
                    <p>
                      <strong>
                        23572002 (Land Line) <br></br>
                        23572003 (Fax) <br></br>
                        9433000084 <br></br>
                        Email : ddgvtmkol-dot@nic.in <br></br>
                        Web link :
                        <a
                          href="https://dot.gov.in/term/term-security"
                          target={"_blank"} rel="noreferrer"
                        >
                          http://www.dot.gov.in/term/term-security
                        </a>
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TERM_Cell;
